export enum LanguageVersion {
    Polish,
    Czech,
    Slovakian,
    English,
}
